import { MainMenuAnalytics } from "../main-menu/main-menu-analytics";

export namespace HeaderAnalytics {
    export const pushNavigationClick = (label: string): void => {
        MainMenuAnalytics.pushNavigationClick(label);
    };
}
